/**
 * 菜单配置 — 角色-模块权限矩阵
 * 
 * roles: 哪些角色可以看到这个菜单项
 * readOnly: 列在这里的角色只有只读权限（组件内自行判断）
 * 
 * 官员角色细分：
 * - OFFICIAL_PROJECT:    项目官员（创建项目）
 * - OFFICIAL_SETTLEMENT: 结算官员（提交劳务结算）
 * - OFFICIAL_AUDIT:      审核官员（审核结算单）
 */
export const MENU_CONFIG = [
  {
    key: 'projects',
    label: '项目管理',
    icon: 'el-icon-folder-opened',
    roles: ['ADMIN', 'OFFICIAL_PROJECT', 'OFFICIAL_SETTLEMENT', 'OFFICIAL_AUDIT', 'ASSISTANT', 'SPONSOR'],
    readOnly: ['OFFICIAL_SETTLEMENT', 'OFFICIAL_AUDIT', 'SPONSOR'],
  },
  {
    key: 'supplierCenterList',
    label: '结算中心',
    icon: 'el-icon-s-order',
    roles: ['ADMIN', 'OFFICIAL_SETTLEMENT', 'ASSISTANT'],
  },
  {
    key: 'spendingManage',
    label: '结算单管理',
    icon: 'el-icon-document-checked',
    roles: ['ADMIN', 'ASSISTANT', 'OFFICIAL_SETTLEMENT'],
  },
  {
    key: 'settlementCenter',
    label: '审核中心',
    icon: 'el-icon-money',
    roles: ['ADMIN', 'OFFICIAL_AUDIT'],
  },
  {
    key: 'myMeetings',
    label: '我的会议',
    icon: 'el-icon-date',
    roles: ['ADMIN', 'OFFICIAL_PROJECT', 'OFFICIAL_SETTLEMENT', 'OFFICIAL_AUDIT', 'ASSISTANT', 'DOCTOR', 'SPONSOR'],
  },
  {
    key: 'userManage',
    label: '用户管理',
    icon: 'el-icon-user',
    roles: ['ADMIN', 'ASSISTANT'],
  },
  {
    key: 'healthManage',
    label: '文章管理',
    icon: 'el-icon-reading',
    roles: ['ADMIN', 'ASSISTANT'],
  },
  {
    key: 'permissionConfig',
    label: '权限配置',
    icon: 'el-icon-setting',
    roles: ['ADMIN'],
  },
  {
    key: 'configManage',
    label: '参数配置',
    icon: 'el-icon-s-tools',
    roles: ['ADMIN'],
  },
  {
    key: 'aiRule',
    label: 'AI 审核配置',
    icon: 'el-icon-cpu',
    roles: ['ADMIN'],
  },
];

/**
 * 登录后各角色的默认首页
 */
export const DEFAULT_PAGE = {
  ADMIN: 'projects',
  OFFICIAL_PROJECT: 'projects',
  OFFICIAL_SETTLEMENT: 'supplierCenterList',
  OFFICIAL_AUDIT: 'settlementCenter',
  ASSISTANT: 'projects',
  DOCTOR: 'myMeetings',
  SPONSOR: 'projects',
};

/**
 * AI 审核中心内部子页路径集合 - 便于菜单高亮判断
 */
export const AI_AUDIT_PAGES = ['aiRule', 'aiCheckItem', 'aiLlm', 'aiAuditTask'];

/**
 * 判断角色是否为任意一种官员类型
 */
export function isOfficialRole(role) {
  return role && role.startsWith('OFFICIAL');
}

/**
 * 判断当前角色是否对某模块只读
 */
export function isReadOnly(menuKey, role) {
  const item = MENU_CONFIG.find(m => m.key === menuKey);
  return item?.readOnly?.includes(role) || false;
}
